import ProgressLoadingBar from './ProgressLoadingBar';
export default ProgressLoadingBar;
